/** Короткі підписи статусів для картки в списку (у деталях — повні з Constants.ts) */
export const TASK_STATUS_LABELS: Record<string, string> = {
    assigned_executor: 'Призначено',
    execution_started: 'Виконання',
    loading_started: 'Завантаження',
    arrived_at_unloading: 'На розвантаженні',
    unloading_started: 'Розвантаження',
    completed_by_driver: 'Завершено',
    completed_by_dispatcher: 'Підтверджено',
}

export const TASK_STATUS_COLORS: Record<string, string> = {
    assigned_executor: '#1890ff',
    execution_started: '#13c2c2',
    loading_started: '#faad14',
    arrived_at_unloading: '#722ed1',
    unloading_started: '#eb2f96',
    completed_by_driver: '#a0d911',
    completed_by_dispatcher: '#52c41a',
}

export type TaskActionIcon = 'play' | 'load' | 'arrive' | 'unload' | 'loop' | 'check'

export interface TaskAction {
    label: string
    next: string
    /** Піктограма дії (див. TaskActionButtons) */
    icon: TaskActionIcon
    /** success — зелена «Завершити», інакше основна помаранчева */
    tone?: 'success'
    /** Власне питання у вікні підтвердження; без нього — «змінити статус на …» */
    confirmQuestion?: string
}

/** Наступні дії водія за статусом; порожньо — дій немає */
export const TASK_ACTIONS: Record<string, TaskAction[]> = {
    assigned_executor: [{ label: 'Розпочати виконання', next: 'execution_started', icon: 'play' }],
    execution_started: [{ label: 'Розпочати завантаження', next: 'loading_started', icon: 'load' }],
    loading_started: [{ label: 'Прибув на розвантаження', next: 'arrived_at_unloading', icon: 'arrive' }],
    arrived_at_unloading: [{ label: 'Розпочати розвантаження', next: 'unloading_started', icon: 'unload' }],
    unloading_started: [
        { label: 'Нова ходка', next: 'loading_started', icon: 'loop', confirmQuestion: 'Розпочати нову ходку?' },
        { label: 'Завершити завдання', next: 'completed_by_driver', tone: 'success', icon: 'check' },
    ],
    completed_by_driver: [],
    completed_by_dispatcher: [],
}

/** Завдання, яке водій зараз виконує (від «Розпочато виконання» до «Розпочато розвантаження») */
export const IN_PROGRESS_STATUSES = [
    'execution_started',
    'loading_started',
    'arrived_at_unloading',
    'unloading_started',
]
